export default __webpack_public_path__ + "static/media/img7.bd9fe1c2.PNG";